export enum Architecture {
    ios = "ios",
    android = "android",
    web = "web",
}
